"use client";

import * as React from 'react';
import { useRouter, useSearchParams, usePathname } from 'next/navigation';
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from '@/components/ui/select';

// Backend supports 'new'/'old' plus (2026-08-10, charter-8 Phase 1)
// 'trending' — a real sort backed by the materialized
// ContentTrendingSnapshots board (weekly engagement window), not the old
// silent fall-through to CreatedAt DESC. 'views'/'likes' stay removed until
// their signals are real.
const SORT_OPTIONS: Array<{ value: string; label: string }> = [
  { value: 'latest', label: 'Newest' },
  { value: 'trending', label: 'Trending' },
  { value: 'oldest', label: 'Oldest' },
];

export default function VideoSortBar({ initial = 'latest' }: { initial?: string }) {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const rawSort = (searchParams?.get('sort') || initial || 'latest').toLowerCase();
  const current = SORT_OPTIONS.some(o => o.value === rawSort) ? rawSort : 'latest';

  function onChange(next: string) {
    const params = new URLSearchParams(searchParams?.toString() || '');
    if (next && next !== 'latest') params.set('sort', next); else params.delete('sort');
    router.replace(`${pathname}?${params.toString()}`);
  }

  return (
    <div className="flex items-center gap-2">
      <div className="w-44">
        <Select value={current} onValueChange={onChange}>
          <SelectTrigger className="w-full">
            <SelectValue placeholder="Sort">{SORT_OPTIONS.find(o => o.value === current)?.label || 'Newest'}</SelectValue>
          </SelectTrigger>
          <SelectContent>
            {SORT_OPTIONS.map(o => (<SelectItem key={o.value} value={o.value}>{o.label}</SelectItem>))}
          </SelectContent>
        </Select>
      </div>
    </div>
  );
}
